// @flow
import { compose, applyMiddleware, createStore, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import logger from 'redux-logger'
import { reducer as ui } from 'redux/modules/ui'
import { reducer as config } from 'redux/modules/config'
import { reducer as account } from 'redux/modules/account'
import { reducer as eventSetting } from 'redux/modules/eventSetting'
import { reducer as network } from 'redux/modules/network'
import { reducer as hostSimulation } from 'redux/modules/hostSimulation'
import createSagaMiddleware from 'redux-saga'
import rootSaga from 'redux/modules/sagas'

const saga = createSagaMiddleware()

let composeEnhancers = compose
let middlewares = [thunk, saga]
if (process.env.NODE_ENV === 'development') {
  /* eslint-disable no-underscore-dangle, no-undef */
  composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose
  /* eslint-enable no-underscore-dangle, no-undef */
  middlewares.push(logger)
}

export default (initialState: Object = {}) => {
  const store = createStore(
    combineReducers({
      ui,
      config,
      account,
      eventSetting,
      network,
      hostSimulation,
    }),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  )
  saga.run(rootSaga)
  return store
}
